export default "__VITE_ASSET__054SDV1S__"